/* tslint:disable */
/* eslint-disable */
/**
 * GlassHouse.Dashboard.Api | v1
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { ActorActivityRecordActorUserId } from './ActorActivityRecordActorUserId';
import {
    ActorActivityRecordActorUserIdFromJSON,
    ActorActivityRecordActorUserIdFromJSONTyped,
    ActorActivityRecordActorUserIdToJSON,
    ActorActivityRecordActorUserIdToJSONTyped,
} from './ActorActivityRecordActorUserId';
import type { CreateTimeEntryRequestAppointmentId } from './CreateTimeEntryRequestAppointmentId';
import {
    CreateTimeEntryRequestAppointmentIdFromJSON,
    CreateTimeEntryRequestAppointmentIdFromJSONTyped,
    CreateTimeEntryRequestAppointmentIdToJSON,
    CreateTimeEntryRequestAppointmentIdToJSONTyped,
} from './CreateTimeEntryRequestAppointmentId';
import type { AppliedDiscount } from './AppliedDiscount';
import {
    AppliedDiscountFromJSON,
    AppliedDiscountFromJSONTyped,
    AppliedDiscountToJSON,
    AppliedDiscountToJSONTyped,
} from './AppliedDiscount';
import type { BalanceLineType } from './BalanceLineType';
import {
    BalanceLineTypeFromJSON,
    BalanceLineTypeFromJSONTyped,
    BalanceLineTypeToJSON,
    BalanceLineTypeToJSONTyped,
} from './BalanceLineType';

/**
 * 
 * @export
 * @interface TuitionLine
 */
export interface TuitionLine {
    /**
     * 
     * @type {BalanceLineType}
     * @memberof TuitionLine
     */
    type?: BalanceLineType;
    /**
     * 
     * @type {number}
     * @memberof TuitionLine
     */
    amount?: number;
    /**
     * 
     * @type {boolean}
     * @memberof TuitionLine
     */
    eligibleForDiscount?: boolean;
    /**
     * 
     * @type {ActorActivityRecordActorUserId}
     * @memberof TuitionLine
     */
    classId?: ActorActivityRecordActorUserId | null;
    /**
     * 
     * @type {ActorActivityRecordActorUserId}
     * @memberof TuitionLine
     */
    locationId?: ActorActivityRecordActorUserId | null;
    /**
     * 
     * @type {CreateTimeEntryRequestAppointmentId}
     * @memberof TuitionLine
     */
    appointmentId?: CreateTimeEntryRequestAppointmentId | null;
    /**
     * 
     * @type {CreateTimeEntryRequestAppointmentId}
     * @memberof TuitionLine
     */
    bookingId?: CreateTimeEntryRequestAppointmentId | null;
    /**
     * 
     * @type {string}
     * @memberof TuitionLine
     */
    description?: string | null;
    /**
     * 
     * @type {number}
     * @memberof TuitionLine
     */
    discountAmount?: number;
    /**
     * 
     * @type {number}
     * @memberof TuitionLine
     */
    netAmount?: number;
    /**
     * 
     * @type {Array<AppliedDiscount>}
     * @memberof TuitionLine
     */
    appliedDiscounts?: Array<AppliedDiscount>;
}



/**
 * Check if a given object implements the TuitionLine interface.
 */
export function instanceOfTuitionLine(value: object): value is TuitionLine {
    return true;
}

export function TuitionLineFromJSON(json: any): TuitionLine {
    return TuitionLineFromJSONTyped(json, false);
}

export function TuitionLineFromJSONTyped(json: any, ignoreDiscriminator: boolean): TuitionLine {
    if (json == null) {
        return json;
    }
    return {
        
        'type': json['type'] == null ? undefined : BalanceLineTypeFromJSON(json['type']),
        'amount': json['amount'] == null ? undefined : json['amount'],
        'eligibleForDiscount': json['eligibleForDiscount'] == null ? undefined : json['eligibleForDiscount'],
        'classId': json['classId'] == null ? undefined : ActorActivityRecordActorUserIdFromJSON(json['classId']),
        'locationId': json['locationId'] == null ? undefined : ActorActivityRecordActorUserIdFromJSON(json['locationId']),
        'appointmentId': json['appointmentId'] == null ? undefined : CreateTimeEntryRequestAppointmentIdFromJSON(json['appointmentId']),
        'bookingId': json['bookingId'] == null ? undefined : CreateTimeEntryRequestAppointmentIdFromJSON(json['bookingId']),
        'description': json['description'] == null ? undefined : json['description'],
        'discountAmount': json['discountAmount'] == null ? undefined : json['discountAmount'],
        'netAmount': json['netAmount'] == null ? undefined : json['netAmount'],
        'appliedDiscounts': json['appliedDiscounts'] == null ? undefined : ((json['appliedDiscounts'] as Array<any>).map(AppliedDiscountFromJSON)),
    };
}

export function TuitionLineToJSON(json: any): TuitionLine {
    return TuitionLineToJSONTyped(json, false);
}

export function TuitionLineToJSONTyped(value?: TuitionLine | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'type': BalanceLineTypeToJSON(value['type']),
        'amount': value['amount'],
        'eligibleForDiscount': value['eligibleForDiscount'],
        'classId': ActorActivityRecordActorUserIdToJSON(value['classId']),
        'locationId': ActorActivityRecordActorUserIdToJSON(value['locationId']),
        'appointmentId': CreateTimeEntryRequestAppointmentIdToJSON(value['appointmentId']),
        'bookingId': CreateTimeEntryRequestAppointmentIdToJSON(value['bookingId']),
        'description': value['description'],
        'discountAmount': value['discountAmount'],
        'netAmount': value['netAmount'],
        'appliedDiscounts': value['appliedDiscounts'] == null ? undefined : ((value['appliedDiscounts'] as Array<any>).map(AppliedDiscountToJSON)),
    };
}

